


















































import { Component, Vue } from 'vue-property-decorator';

@Component({
    components: {
    },
})
export default class CreateLeagueStep4 extends Vue {
    private public = false;

    private update() {
        this.$emit("updateLeague", [
            {
                key: "public",
                value: this.public
            }
        ])
    }
}
